import "./style.less";

export default function LanesByDay() {
    return {
        restrict: "E",
        scope: {
            searchResults: "=",
            showAlreadyReserved: "=",
            resourceDependencies: "<",
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            searchResultFactory,
            houseService,
            Resources,
            Basket,
            $document,
            siteService,
            moment,
            Log
        ) {
            const log = {
                string: (string, theme = "info") => {
                    Log.string("Periods", string, theme);
                },
                obj: (title, obj, theme = "info") => {
                    Log.obj("Periods : " + title, obj, theme);
                },
            };

            $scope.siteService = siteService;

            const parentLanes = $scope.searchResults.ParentLanes;
            const lanes = parentLanes[0].Lanes;

            const resourceDependencies = $scope.resourceDependencies;

            /*******************
             * - Scope bindings
             *******************/
            $scope.searchFilter = houseService.searchFilter;
            $scope.currentBookings = Basket.currentBookings;

            $scope.displayLanes = true;

            $scope.fadeEvent = {
                ongoing: false,
                in: false,
                out: false,
            };

            /************************
             *
             * - EVENTS
             **/

            // $scope.$on("bookings-cancelled-broadcast", function () {
            //     $scope.currentBookings = Basket.currentBookings;
            // });

            var bookingRemovedEventListener = $rootScope.$on(
                "booking-removed-basket",
                function () {
                    log.string("$on", "booking-removed-basket", "highlight");

                    initPeriods();
                }
            );
            $scope.$on("$destroy", bookingRemovedEventListener);

            var searchUpdateEventListener = $scope.$on(
                "search-updated-broadcast",
                function ($event, searchResults) {
                    log.string("search-updated-broadcast", "highlight");

                    $scope.searchResults = searchResults;

                    // new search Results from API
                    initPeriods();

                    searchResultFactory.anyPeriodsWithinSelectedTime(
                        parentLanes,
                        $scope.searchFilter
                    );
                }
            );
            $scope.$on("$destroy", searchUpdateEventListener);

            // Runs on controller init and search Update
            const initPeriods = function () {
                log.string("initPeriods called");

                // If any parentLanes
                if (parentLanes.length !== 0) {
                    // Re init on every new searchResult from API
                    $scope.processPeriods();
                }
            };

            /************************
             *
             * - Scope Functions
             **/

            // Pre process Lanes
            const addPropertiesToLanesObj = function () {
                lanes.forEach((lane) => {
                    lane.aExcludedPeriod = [];
                    lane.aSelectedPeriod = [];
                });
            };

            var bookingAddedEventListener = $rootScope.$on(
                "booking-added-to-basket",
                function () {
                    // When repeatable period is added.. process periods
                    $scope.processPeriods();
                }
            );
            $scope.$on("$destroy", bookingAddedEventListener);

            $scope.$watch("showAlreadyReserved", function () {
                $scope.processPeriods();
            });

            /**
             * Called by child directive ($scope) - When period is added
             */
            $scope.processPeriods = function () {
                log.string("ProcessPeriods called");

                //Re-init Lanes Selections
                addPropertiesToLanesObj();

                // GO THROUGH THE BOOKINGS IN THE BASKET
                $scope.currentBookings.forEach((booking) => {
                    // as of this version, each booking will only have one period
                    var periodInBasket = booking.Periods[0];

                    // Compare : Booking Date vs. current display date
                    const searchDate = moment(
                        houseService.searchFilter.startDate,
                        "DD-MM-YYYY"
                    ).format("DD-MM-YYYY");

                    if (searchDate == booking._periodSearchDate) {
                        // find The correct Lane for further processing
                        const bookingLane = getLaneById(
                            booking.Periods[0].LaneID,
                            lanes
                        );

                        log.string(
                            "Process booking : " + booking._periodSearchDate,
                            "highlight"
                        );

                        // Iterate Lanes for each booking
                        // + Add selected periods to each Lane
                        // + Push un-available period Keys into each : lane.aExcludedPeriodKeys
                        if (bookingLane) {
                            // log.string(
                            //     "BookingLane: " +
                            //         bookingLane.LaneName +
                            //         " ID : " +
                            //         bookingLane.LaneID
                            // );

                            bookingLane.dependencies =
                                Resources.lookupLaneDependencies(
                                    bookingLane.LaneID,
                                    resourceDependencies
                                );

                            log.obj("BookingLane : ", bookingLane);
                            log.obj(
                                "BookingLane dependencies : ",
                                bookingLane.dependencies
                            );

                            lanes.forEach((lane) => {
                                if (
                                    bookingLane.dependencies.indexOf(
                                        lane.LaneID
                                    ) !== -1
                                ) {
                                    log.string(
                                        "Other lane : " +
                                            lane.LaneName +
                                            " - ID : " +
                                            lane.LaneID +
                                            " - dependency lanes at : " +
                                            bookingLane.dependencies.indexOf(
                                                lane.LaneID
                                            )
                                    );

                                    log.string(
                                        "PROCESS DEPENDECY LANE: : " +
                                            lane.LaneID
                                    );
                                    processLanePeriods(periodInBasket, lane);
                                }
                            });

                            // When viewing other date
                            processLanePeriods(periodInBasket, bookingLane);
                        }
                    } else {
                        // console.log("do not process booking");
                    }
                });

                // POST PROCESS -> LOOP EACH LANE
                lanes.forEach((lane) => {
                    // Inspecting period.AlreadyReserved
                    const nonReservedPeriods = lane.Prices.filter(
                        (period) => !period.AlreadyReserved
                    );

                    // hide lane if !showAlreadyReserved + nonReservedPeriods.length == 0
                    lane._display = !$scope.showAlreadyReserved
                        ? !!nonReservedPeriods.length
                        : true;

                    lane.Prices.forEach((period) => {
                        // Disable period ?
                        period.disabled =
                            lane.aExcludedPeriod.indexOf(period.UniqueKey) !==
                            -1
                                ? period.selected
                                    ? false
                                    : true
                                : false;

                        // Make sure only periods in basket are selected in lanes view!
                        if (period.selected) {
                            if (
                                lane.aSelectedPeriod.indexOf(
                                    period.UniqueKey
                                ) == -1
                            ) {
                                period.selected = false;
                            }
                        }
                    });
                });

                log.string("**************");
            };

            /**
             * processLanePeriods
             * LOOP EACH PERIOD IN LANE FOR EACH BOOKING IN BASKET!
             * @param  {obj} periodInBasket [description]
             * @param  {obj} lane           [description]
             *
             * Updates the lane object with "selected" and "excluded" periods
             */

            const processLanePeriods = (periodInBasket, lane) => {
                lane.Prices.forEach((period) => {
                    const logString =
                        period.UniqueKey +
                        " : PERIOD \n " +
                        periodInBasket.UniqueKey +
                        " : BASKET \n" +
                        " Match : " +
                        (period.UniqueKey == periodInBasket.UniqueKey);

                    // update Lane Object With Selected Periods
                    if (period.UniqueKey == periodInBasket.UniqueKey) {
                        period.selected = true;

                        // UPDATE THE LANE OBJECT
                        lane.aSelectedPeriod.push(period.UniqueKey);

                        log.string(logString, "highlight");
                    } else {
                        //log.string(logString);
                    }

                    // update Lane Object With Excluded Periods
                    if (
                        (period.BookingStart >= periodInBasket.BookingStart &&
                            period.BookingStart < periodInBasket.BookingEnd) ||
                        (period.BookingEnd > periodInBasket.BookingStart &&
                            period.BookingEnd <= periodInBasket.BookingEnd)
                    ) {
                        if (
                            lane.aExcludedPeriod.indexOf(period.UniqueKey) == -1 // if not allready there
                        ) {
                            // UPDATE THE LANE OBJECT
                            lane.aExcludedPeriod.push(period.UniqueKey);
                        }
                    }
                });
            };

            // Helper function
            const getLaneById = function (periodlaneID, lanes) {
                return lanes.find((lane) => lane.LaneID == periodlaneID);
            };

            // SHOW OR HIDE LANE
            // Filter Lanes depending on availability in current selected Time
            // $scope.showLane = function (lane) {
            //     var aPeriodsInLaneWithinSelectedTime = [];

            //     //Is the lane empty within the given time selection?
            //     lane.Prices.forEach((period) => {
            //         if ($scope.isPeriodWithinSelectedTime(period)) {
            //             aPeriodsInLaneWithinSelectedTime.push(period);
            //         }
            //     });

            //     if (aPeriodsInLaneWithinSelectedTime.length != 0) {
            //         return true;
            //     }

            //     return false;
            // };

            /**
             * Any Periods Within Selected Time
             *
             * @param  {obj}  parentLanes   [description]
             * @param  {obj}  searchFilter  start / end time
             * @return {Boolean}            true/false
             */
            searchResultFactory.anyPeriodsWithinSelectedTime(
                parentLanes,
                $scope.searchFilter
            );

            /**
             * is Period Within Selected Time
             *
             * @param  {obj}  period [description]
             * @return {Boolean}        [description]
             */
            $scope.isPeriodWithinSelectedTime = function (period) {
                return searchResultFactory.isPeriodWithinSelectedTime(
                    period,
                    $scope.searchFilter
                );
            };

            $scope.bookingsCancelled = function () {};

            // on controller instantiation
            initPeriods();
        },
    };
}
